import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DomainService {

  constructor() { }
}

export interface AcademicYear {
  id: number;
  name: string;
}

export interface DegreeType {
  id: string;
  name: string;
}

export interface GraduationType {
  id: string;
  name: string;
}

export interface StudyType {
  id: string;
  name: string;
}

export interface Faculty {
  id: string;
  name: string;
}

export interface Programme {
  id: number;
  name: string;
  streams: Array<ProgrammeStream>;
  yearLevels: Array<YearLevel>;
}

export interface ProgrammeStream {
  id: string;
  name: string;
}

export interface YearLevel {
  id: number;
  name: string;
}

export interface Gender {
  id: string;
  name: string;
}

export interface QuotationDetail {
  studentType: number;
  academicYear: number;
  degreeTypeId: string;
  degreeTypeName: string;
  gradTypeId: string;
  gradTypeName: string;
  studyTypeId: string;
  studyTypeName: string;
  facultyId: string;
  facultyName: string;
  programmeId: number;
  programmeName: string;
  streamId: string;
  streamName: string;
  yearLevelId: number;
  yearLevelName: string;
  programmeDuration: number;
  chargeByModule: boolean
  programmeCost: number;
  includeRes: boolean;
  generateQuotation: boolean;
  generateProforma: boolean;

  quotationsModules: Array<QuotationModule>;
  residence: ResidenceItem;
  personalInfo: PersonalInfo;
  proformaInfo: ProformaInfo;
}

export interface QuotationModule {
  modChecked: boolean;
  modSubChecked: boolean;
  rulesKey: number;
  sequence: number;
  connector: string;
  moduleCode: string;
  moduleName: string;
  moduleCost: number;
  moduleCredits: number;
  electiveGroup1: number;
  electiveGroup2: number;
  compulsorySubGroup: boolean;
  isCore: boolean;
  isDisabled: boolean;
  isSubDisabled: boolean;
}

export interface ModuleProgramme {
  year: number;
  programme: number;
  programmeName: string;
  yearLevel: number;
  studyType: string;
  maxYearLevelCredits: number;
  costLocal: number;
  costInt: number;
  chargeType: string;
  chargeTypeDscr: string;

  modules: Array<Module>;
}

export interface Module {
  year: number;
  programme: number;
  stream: string;
  yearLevel: number;
  moduleCode: string;
  moduleName: string;
  costLocal: number;
  costInt: number;
  credits: number;
  ruleType: string;
  rulesKey: number;
  sequence: number;
  connector: string;
  electiveGroup1: number;
  electiveGroup2: number;
  compulsorySubGroup: boolean;
}

export interface ResidenceItem {
  selected: boolean;
  roomTypeId: string;
  roomTypeName: string;
  maxPrice: number;
  toolTip: string;
}

export interface PersonalInfo {
  initials: string;
  surname: string;
  email: string
  sendEmail: boolean;
}

export interface ProformaInfo {
  companyName: string;
  contactPerson: string;
  contactNumber: string;
  companyRegNumber: string;
  vatNumber: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  postalCode: string;
  country: string;
}

export interface DownPayment {
  key: string;
  amount: number;
}